
import htltImg from "../../../assets/images/service/htlt.png";

import {
  Settings,
  Factory,
  FileCheck,
  ShieldCheck,
  Clock,
  Zap,
  HardHat,
  TrendingUp,
  Maximize,
  UserCheck
} from "lucide-react";
import ServiceSidebar from "../sidebar";

export default function HTLT() {
  return (
    <>
      <section className="service-detail py-10">
        <div className="container">
          <div className="service-detail-inner">
            {/* Feature Section */}
            <div className="service-feature mb-8">
              <div className="row  align-items-center gy-5">


                {/* Content */}
                <div className="col-lg-6 px-8 feature-content">
                  <h2 className="fw-bold mb-2">
                    Reiable  <span className="green">HT & LT Connectivity</span> For Modern Infrastructure
                  </h2>
                  <p className="mb-4">
                    Denial Enterprise provides end-to-end High Tension (HT) and Low Tension (LT)
                    electrical connectivity solutions for EV charging stations, industrial units,
                    and commercial facilities.
                  </p>

                  <div className="feature-points">
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>End-to-end design, execution & commissioning</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Utility-compliant & safety-driven solutions</span>
                    </div>
                    <div className="point">
                      <i className="fa fa-check-circle"></i>
                      <span>Future-ready power infrastructure</span>
                    </div>
                  </div>
                </div>
                {/* Image */}
                <div className="col-lg-6">
                  <div className="feature-image position-relative">
                    <img
                      src={htltImg}
                      alt="HT LT Connectivity"
                      className="w-100 rounded2 shadow"
                    />
                    <div className="image-badge">
                      <i className="fa fa-bolt"></i> HT–LT Power Solutions
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* Service Info */}
            <div className="service-info">
              <div className="row mt-6 gx-lg-5 gy-5">
                <div className="col-lg-4">
                  <ServiceSidebar />
                </div>
                {/* Left Content */}
                <div className="col-lg-8">
                  <div className="about-service mb-6">
                    <h3 className="mb-2">About the Service</h3>
                    <p className="mb-3">
                      Denial Enterprise delivers end-to-end HT & LT electrical connectivity solutions designed for EV charging infrastructure, commercial buildings, industrial plants, and high-load facilities. From concept to commissioning, we ensure reliable, compliant, and future-ready power systems.

                      Our team manages the complete lifecycle of electrical infrastructure—including planning, detailed engineering, procurement, installation, testing, and final handover—while strictly adhering to utility norms and safety standards.
                    </p>

                    <ul className="icon-list-modern icon-list list-unstyled">
                      <li>
                        <span className="icon-wrap">
                          <Settings size={22} />
                        </span>
                        <span>HT & LT Panel Installation & Commissioning</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Factory size={22} />
                        </span>
                        <span>Transformer Installation & Load Management</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <FileCheck size={22} />
                        </span>
                        <span>Utility Coordination & Statutory Approvals</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <ShieldCheck size={22} />
                        </span>
                        <span>Metering, Earthing & Protection Systems</span>
                      </li>
                    </ul>

                  </div>

                  {/* Benefits */}
                  <div className="service-benefit">
                    <h4 className="mb-3">How You Benefit</h4>
                    <p className="mb-6">
                      With our expertise in HT–LT connectivity, clients benefit
                      from faster approvals, reduced downtime, enhanced safety,
                      and long-term reliability of their electrical systems.Our solutions are designed to optimize power distribution efficiency while ensuring full compliance with utility and safety standards.
                    </p>
                    <ul className="icon-list-modern benefit-list">
                      <li>
                        <span className="icon-wrap">
                          <Clock size={22} />
                        </span>
                        <span>Faster utility approvals and smoother execution</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Zap size={22} />
                        </span>
                        <span>Minimized downtime and power disruptions</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <HardHat size={22} />
                        </span>
                        <span>Enhanced safety for personnel and equipment</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <TrendingUp size={22} />
                        </span>
                        <span>Reliable long-term HT & LT system performance</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <Maximize size={22} />
                        </span>
                        <span>Scalable infrastructure for future expansion</span>
                      </li>

                      <li>
                        <span className="icon-wrap">
                          <UserCheck size={22} />
                        </span>
                        <span>Single-point responsibility from design to commissioning</span>
                      </li>
                    </ul>


                  </div>
                </div>

                {/* Right Sidebar */}


              </div>
            </div>

          </div>
        </div>
      </section>

    </>
  );
}
